export default "__VITE_ASSET__6ee29c12__"